// extracted by mini-css-extract-plugin
export default {"wrapper":"card-flip_wrapper__wIGxG","cardFlipInner":"card-flip_cardFlipInner__EqkD2","cardFlipBack":"card-flip_cardFlipBack__vE3E4","cardFlipFront":"card-flip_cardFlipFront__FwWPn"};